"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchFallbackHtml = void 0;
function fetchFallbackHtml(url) {
    var headers = {
        Accept: 'text/html'
    };
    try {
        var _a = new URL(url), origin_1 = _a.origin, username = _a.username, password = _a.password, pathname = _a.pathname;
        if (username && password) {
            url = "" + origin_1 + pathname;
            headers.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        // eslint-disable-next-line no-empty
        // tslint:disable-next-line: no-empty
    }
    catch (_b) { }
    return fetch(url, { headers: headers });
}
exports.fetchFallbackHtml = fetchFallbackHtml;
